export const tablesConstants = {
  GET_ALL_TABLES_REQUEST: "GET_ALL_TABLES_REQUEST",
  GET_ALL_TABLES_SUCCESS: "GET_ALL_TABLES_SUCCESS",
  GET_ALL_TABLES_FAILURE: "GET_ALL_TABLES_FAILURE",

  GET_TABLE_BY_ID_REQUEST: "GET_TABLE_BY_ID_REQUEST",
  GET_TABLE_BY_ID_SUCCESS: "GET_TABLE_BY_ID_SUCCESS",
  GET_TABLE_BY_ID_FAILURE: "GET_TABLE_BY_ID_FAILURE",

  GET_TOP_CARDS_TABLES_REQUEST: "GET_TOP_CARDS_TABLES_REQUEST",
  GET_TOP_CARDS_TABLES_SUCCESS: "GET_TOP_CARDS_TABLES_SUCCESS",
  GET_TOP_CARDS_TABLES_FAILURE: "GET_TOP_CARDS_TABLES_FAILURE",

  UPLOAD_DICTIONARY_BY_TABLE_ID_REQUEST: "UPLOAD_DICTIONARY_BY_TABLE_ID_REQUEST",
  UPLOAD_DICTIONARY_BY_TABLE_ID_SUCCESS: "UPLOAD_DICTIONARY_BY_TABLE_ID_SUCCESS",
  UPLOAD_DICTIONARY_BY_TABLE_ID_FAILURE: "UPLOAD_DICTIONARY_BY_TABLE_ID_FAILURE",

  ADD_TABLE_REQUEST: "ADD_TABLE_REQUEST",
  ADD_TABLE_SUCCESS: "ADD_TABLE_SUCCESS",
  ADD_TABLE_FAILURE: "ADD_TABLE_FAILURE",

  GET_TABLES_BY_CONNECTION_ID_REQUEST: "GET_TABLES_BY_CONNECTION_ID_REQUEST",
  GET_TABLES_BY_CONNECTION_ID_SUCCESS: "GET_TABLES_BY_CONNECTION_ID_SUCCESS",
  GET_TABLES_BY_CONNECTION_ID_FAILURE: "GET_TABLES_BY_CONNECTION_ID_FAILURE",

  GET_DATA_DICTIONARY_BY_TABLE_ID_REQUEST: "GET_DATA_DICTIONARY_BY_TABLE_ID_REQUEST",
  GET_DATA_DICTIONARY_BY_TABLE_ID_SUCCESS: "GET_DATA_DICTIONARY_BY_TABLE_ID_SUCCESS",
  GET_DATA_DICTIONARY_BY_TABLE_ID_FAILURE: "GET_DATA_DICTIONARY_BY_TABLE_ID_FAILURE",

  CONFIGURE_TABLE_BY_ID_REQUEST: "CONFIGURE_TABLE_BY_ID_REQUEST",
  CONFIGURE_TABLE_BY_ID_SUCCESS: "CONFIGURE_TABLE_BY_ID_SUCCESS",
  CONFIGURE_TABLE_BY_ID_FAILURE: "CONFIGURE_TABLE_BY_ID_FAILURE",

  EDIT_TABLE_BY_ID_REQUEST: "EDIT_TABLE_BY_ID_REQUEST",
  EDIT_TABLE_BY_ID_SUCCESS: "EDIT_TABLE_BY_ID_SUCCESS",
  EDIT_TABLE_BY_ID_FAILURE: "EDIT_TABLE_BY_ID_FAILURE",

  EDIT_DATA_QUALITY_BY_ID_REQUEST: "EDIT_DATA_QUALITY_BY_ID_REQUEST",
  EDIT_DATA_QUALITY_BY_ID_SUCCESS: "EDIT_DATA_QUALITY_BY_ID_SUCCESS",
  EDIT_DATA_QUALITY_BY_ID_FAILURE: "EDIT_DATA_QUALITY_BY_ID_FAILURE",

  GET_DATA_QUALITY_BY_TABLE_ID_REQUEST: "GET_DATA_QUALITY_BY_TABLE_ID_REQUEST",
  GET_DATA_QUALITY_BY_TABLE_ID_SUCCESS: "GET_DATA_QUALITY_BY_TABLE_ID_SUCCESS",
  GET_DATA_QUALITY_BY_TABLE_ID_FAILURE: "GET_DATA_QUALITY_BY_TABLE_ID_FAILURE",

  DELETE_DATA_QUALITY_BY_ID_REQUEST: "DELETE_DATA_QUALITY_BY_ID_REQUEST",
  DELETE_DATA_QUALITY_BY_ID_SUCCESS: "DELETE_DATA_QUALITY_BY_ID_SUCCESS",
  DELETE_DATA_QUALITY_BY_ID_FAILURE: "DELETE_DATA_QUALITY_BY_ID_FAILURE",

  ADD_CONFIGURED_TABLE_REQUEST: "ADD_CONFIGURED_TABLE_REQUEST",
  ADD_CONFIGURED_TABLE_SUCCESS: "ADD_CONFIGURED_TABLE_SUCCESS",
  ADD_CONFIGURED_TABLE_FAILURE: "ADD_CONFIGURED_TABLE_FAILURE",

  GET_TABLES_FILTERS_REQUEST: "GET_TABLES_FILTERS_REQUEST",
  GET_TABLES_FILTERS_SUCCESS: "GET_TABLES_FILTERS_SUCCESS",
  GET_TABLES_FILTERS_FAILURE: "GET_TABLES_FILTERS_FAILURE",

  GET_DATA_DICTIONARY_REQUEST: "GET_DATA_DICTIONARY_REQUEST",
  GET_DATA_DICTIONARY_SUCCESS: "GET_DATA_DICTIONARY_SUCCESS",
  GET_DATA_DICTIONARY_FAILURE: "GET_DATA_DICTIONARY_FAILURE",

  ACTIVATE_TABLE_REQUEST: "ACTIVATE_TABLE_REQUEST",
  ACTIVATE_TABLE_SUCCESS: "ACTIVATE_TABLE_SUCCESS",
  ACTIVATE_TABLE_FAILURE: "ACTIVATE_TABLE_FAILURE",

  FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_REQUEST: "FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_REQUEST",
  FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_SUCCESS: "FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_SUCCESS",
  FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_FAILURE: "FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_FAILURE",

};